module.exports = __webpack_public_path__ + "fb36a44871a4a4dbbab6c012cc41b0de.png";